<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">
      {{ `${auction.name}` }} -
      {{ $t("COMMON.LOGS") }}
    </h3>
    <log-list-table :filterSubject="auction" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "auction-view-logs",

  components: { LogListTable },

  props: ["auction"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
